import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LocationManager} from 'src/app/data/manager/location/location.manager';
import {CustomerManager} from '../../data/manager/customer/customer/customer.manager';
import {SessionStorageManager} from 'src/app/data/manager/session-storage/session-storage.manager';
import { LocalStorageManager } from 'src/app/data/manager/local-storage/local-storage.manager';

@Injectable({
  providedIn: 'root',
})
export class ValidationCodeVm {
  constructor(
    private customerManager: CustomerManager,
    private locationManager: LocationManager,
    private sessionStorageManager: SessionStorageManager,
    private localStorageManager: LocalStorageManager) { }

  sendMessage(data, id): Observable<any> {

    const methodMessage = {
      customerRef: id,
      bySMS: true,
      byCall: false,
      byEmail: false,
      byWhatsApp: false,
    }

    return this.customerManager.sendMessage(methodMessage);
  }

  validateToken(data, id): Observable<any> {
    return this.customerManager.validateToken(data, id);
  }

  customerOnly(data): Observable<any> {
    const dataInfo = {
      customerData: data,
      deliveryType: this.locationManager.getDeliveryType(),
    };

    return this.customerManager.customerOnly(dataInfo);
  }

  selectMethoCode(data): Observable<any>{
    return this.customerManager.sendMessage(data);
  }

  validateSmsToken(data, call?, wapp?): Observable<any> {
    return this.customerManager.validateSmsToken(data, ( (call && call !== 'undefined') ? call : false ), ( (wapp) ? wapp : '' ) );
  }

  getConfigurationModules(moduleName): any {
    const dataHome= this.customerManager.getConfigurationModule('home');
    return dataHome ? dataHome[moduleName] : {};
  }

  getitemSessionStorage(item){
    return this.sessionStorageManager.get(item)
  }

  mergeCarts(idCustomerWebSafeAnonymous): Observable<any> {
    return this.customerManager.mergeCarts(this.localStorageManager.get('customer'), idCustomerWebSafeAnonymous);
  }

  getLocalStorage(item) {
    return this.localStorageManager.get(item);
  }

  private transformLocalData(customer) {
    const { tokensDatastore } = customer;
    if (!tokensDatastore) { return customer; }
    const isAnonymous = !customer.customerId;
    const { idCustomerWebSafe, token, tokenIdWebSafe } = tokensDatastore;
    return {
      ...customer,
      isAnonymous,
      id: customer.customerOldId,
      idCustomerWebSafe,
      token: { token, tokenIdWebSafe },
      idCustomerMulticountry: customer.customerId,
    }
  }

  setLocalCustomer(customer): void {
    const localCustomer = this.transformLocalData(customer);
    this.localStorageManager.set('customer', localCustomer);
  }
}
